import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {MetricsSection} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER} from '/enum/competency.enum';
import {
  REPORT_ALL_FRONTLINE_ORDERS,
  REPORT_ALL_GEN0_ORDERS,
  REPORT_ALL_ORDERS,
  REPORT_ALL_ORGANIZATION_ORDERS,
  REPORT_NEW_FRONTLINE_ORDERS,
  REPORT_NEW_GEN0_ORDERS,
  REPORT_NEW_ORGANIZATION_ORDERS,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

export function useOrdersMetricsSection({
  currentUserCompetency,
  newOrdersCountFrontline,
  newOrdersCountGen0,
  newOrdersCountOrg,
  ordersCountFrontline,
  ordersCountGen0,
  ordersCountOrg,
  onShowInfoPopover,
  onShowReport,
  allOrdersOrgCount,
}: any) {
  const {tt, ts} = useTranslation('screen.clients.section.orders');
  const featureFlag = useSelector(variablesFeatureFlag);
  const ACTIVE_Phase2_DR = shouldReleaseFeature(
    get(featureFlag, 'ACTIVE_Phase2_DR', ''),
  );
  // const ACTIVE_Phase2 = shouldReleaseFeature(
  //   get(featureFlag, 'ACTIVE_Phase2', ''),
  // );

  const listItems = [];
  if (featureFlag.ACTIVE_Phase2_DR) {
    listItems.push({
      label: tt('new.frontline', 'New Frontline Orders'),
      value: newOrdersCountFrontline,
      recordsName: REPORT_NEW_FRONTLINE_ORDERS,
      testID: MetricsSection.metricNewFrontlineOrders,
    });
  }
  //if (featureFlag.ACTIVE_Phase2_DR) { TODO
  if (ACTIVE_Phase2_DR) {
    listItems.push({
      label: tt('total.frontline', 'All Frontline Orders'),
      value: ordersCountFrontline,
      recordsName: REPORT_ALL_FRONTLINE_ORDERS,
      testID: MetricsSection.metricAllFrontlineOrders,
    });
  }
  if (featureFlag.ACTIVE_Phase2) {
    listItems.push({
      label: tt(
        'total.frontline',
        !featureFlag.ACTIVE_Phase2_DR
          ? 'All Frontline Orders'
          : 'All Frontline Orders #2',
      ),
      value: ordersCountFrontline,
      recordsName: REPORT_ALL_ORDERS,
      reportHeading: 'Frontline Qualifying Volume',
      testID: MetricsSection.metricAllFrontlineOrdersNew,
    });
  }
  if (
    currentUserCompetency === BUSINESS_COACH ||
    currentUserCompetency === BUSINESS_LEADER
  ) {
    if (featureFlag.ACTIVE_Phase2_DR) {
      listItems.push({
        label: tt('new.gen0', 'New Generation 0 Orders'),
        value: newOrdersCountGen0,
        recordsName: REPORT_NEW_GEN0_ORDERS,
        testID: MetricsSection.metricNewGeneration0Orders,
      });
    }
    //if (featureFlag.ACTIVE_Phase2_DR) {
    if (ACTIVE_Phase2_DR) {
      listItems.push({
        label: tt('total.gen0', 'All Generation 0 Orders'),
        value: ordersCountGen0,
        recordsName: REPORT_ALL_GEN0_ORDERS,
        testID: MetricsSection.metricAllGeneration0Orders,
      });
    }
    if (featureFlag.ACTIVE_Phase2) {
      listItems.push({
        label: tt(
          'total.gen0',
          !featureFlag.ACTIVE_Phase2_DR
            ? 'All Generation 0 Orders'
            : 'All Generation 0 Orders #2',
        ),
        value: ordersCountGen0,
        recordsName: REPORT_ALL_ORDERS,
        reportHeading: 'Generation 0 Volume',
        testID: MetricsSection.metricAllGeneration0OrdersNew,
      });
    }
  }

  if (currentUserCompetency === BUSINESS_LEADER) {
    if (featureFlag.ACTIVE_Phase2_DR) {
      listItems.push({
        label: tt('new.org', 'New Organization Orders'),
        value: newOrdersCountOrg,
        recordsName: REPORT_NEW_ORGANIZATION_ORDERS,
        testID: MetricsSection.metricNewOrganizationOrders,
      });
    }
    if (featureFlag.ACTIVE_Phase2_DR || featureFlag.ACTIVE_Phase2) {
      listItems.push({
        label: tt('total.org', 'All Organization Orders'),
        value: ordersCountOrg,
        recordsName: REPORT_ALL_ORGANIZATION_ORDERS,
        testID: MetricsSection.metricAllOrganizationOrders,
      });
    }
    //if (featureFlag.ACTIVE_Phase2) {
    if (ACTIVE_Phase2_DR) {
      listItems.push({
        label: tt(
          'total.org',
          !featureFlag.ACTIVE_Phase2_DR
            ? 'All Organization Orders'
            : 'All Organization Orders #2',
        ),
        value: allOrdersOrgCount,
        recordsName: REPORT_ALL_ORDERS,
        reportHeading: 'Total Generation Volume',
        testID: MetricsSection.metricAllOrganizationOrdersNew,
      });
    }
  }

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Order Metrics'),
      body: tt(
        'info.body',
        'View orders from frontline Clients/Coaches (your personal Clients), Generation Zero (Gen 0) Clients/Coaches (those sponsored by you or a Coach on your team down to the first ED or above), or in your organization (all orders on your team).',
      ),
    });

  const onItemPress = ({recordsName, value, reportHeading}: any) =>
    onShowReport({recordsName, loadingData: {total: value}, reportHeading});

  return {listItems, onInfoPress, onItemPress, tt, ts, featureFlag};
}
